var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.7,
    height: 21.85,
    viewBox: "0 0 23.7 21.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(-0.15 -0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(8 18)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(17 18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M19.439,16.85H9.687a2.847,2.847,0,0,1-2.841-2.294L5.175,6.206q-.009-.038-.015-.076L4.3,1.85H1A.85.85,0,0,1,1,.15H5a.85.85,0,0,1,.833.683L6.7,5.15H23a.85.85,0,0,1,.835,1.009l-1.6,8.39v.006A2.847,2.847,0,0,1,19.439,16.85ZM9.68,15.15h9.759a1.149,1.149,0,0,0,1.127-.923L21.973,6.85H7.038l1.476,7.373a1.149,1.149,0,0,0,1.15.927Z",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.bc96dadc794898ebdea2e62cd4afe153.svg";
export { ForwardRef as ReactComponent };